import { DataService } from '@/services/DataService.js'
import Vue from 'vue'
export const namespaced = true

export const state = {
  managers: [],
  departments: []
}

export const mutations = {
  SET (state, [prop, val]) {
    Vue.set(state, prop, val)
  }
}

export const actions = {
  async loadData ({ commit, rootGetters }) {
    const { companyId } = rootGetters['user/user']
    DataService.getManagers({ companyId }).then(({ data: { managers } }) => commit('SET', ['managers', managers]))
    DataService.getDepartments({ companyId }).then(({ data: { departments } }) => commit('SET', ['departments', departments]))
  }
}

export const getters = {
  managers: state => state.managers,
  manager: state => id => state.managers.find(m => m.id === id),
  departments: state => state.departments,
  department: state => id => state.departments.find(d => d.id === id)
}
